import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { documentService } from "../../../../api/services/documentService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
interface MyDocsDTOProps {
  setAllCountries: (countries: []) => void;
  setAllEmpDocsType: (empdoctypes: []) => void;
}
function DTOAddDependents({
  setAllCountries,
  setAllEmpDocsType,
}: MyDocsDTOProps) {
  const selector = useAppSelector((state) => state.authSlice);
  const companyId = useAppSelector((state) => state.authSlice.company_id);
  const dispatch = useAppDispatch();
  async function getAllCountries() {
    const response = await commonServices.getCountries();
    if (response) {
      const { data }: any = response;
      setAllCountries(data);
    }
  }
  async function getAllEmpDocsTypes() {
    const response = await documentService.getEmpDocTypes(companyId);
    if (response) {
      const { data }: any = response;
      setAllEmpDocsType(data);
    }
  }
  useEffect(() => {
    getAllEmpDocsTypes();
    getAllCountries();
  }, []);

  return <></>;
}
export default DTOAddDependents;
